import { CALC_PAGE_TYPES } from 'utils/calculatorUtils';
import CommonDrafts from '../../CommonViews/Drafts';

const Drafts = ({ targetWidth }) => (
  <CommonDrafts targetWidth={targetWidth} pageType={CALC_PAGE_TYPES.CUSTOM} />
);

export default Drafts;
